// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field .v-input__control .v-input__slot[data-v-20fb3fdc]{min-height:auto!important;display:flex!important;align-items:center!important}.required label[data-v-20fb3fdc]:after{content:\"*\"}.colForm[data-v-20fb3fdc]{padding-left:12px!important;padding-right:12px!important;padding-top:0!important;padding-bottom:0!important}", ""]);
// Exports
module.exports = exports;
